import React from "react";
import Info from "../components/Contact/Info";
import Form from "../components/Contact/Form";
import FAQ from "../components/Contact/FAQs";

const Home = () => {
  return (
    <>
      <Info />
      <Form />
      <FAQ />
    </>
  );
};

export default Home;
